var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Model from "../../Model";
import EstablishmentOrderSuppDataText from "./EstablishmentOrderSuppDataText";
var OrderSuppData = /** @class */ (function (_super) {
    __extends(OrderSuppData, _super);
    function OrderSuppData(obj) {
        if (obj === void 0) { obj = {}; }
        var _this = _super.call(this) || this;
        _this.values = [];
        _this.text = '';
        if (typeof obj === 'string') {
            obj = JSON.parse(obj);
        }
        OrderSuppData.buildFromJson(_this, obj);
        return _this;
    }
    OrderSuppData.buildFromJson = function (instance, json) {
        if (json) {
            for (var prop in json) {
                if (json.hasOwnProperty(prop)) {
                    instance[prop] = json[prop];
                }
            }
        }
    };
    OrderSuppData.prototype.exportToJson = function () {
        var JSONSuppData = {};
        JSONSuppData.establishmentOrderSuppDataUid = this.establishmentOrderSuppDataUid;
        JSONSuppData.checked = this.checked;
        JSONSuppData.value = this.value;
        JSONSuppData.values = this.values;
        JSONSuppData.text = this.text;
        return JSONSuppData;
    };
    OrderSuppData.prototype.setData = function (establishmentOrderSuppData, data) {
        if (establishmentOrderSuppData.type === 'CHECKBOX') {
            if (data.checked !== undefined) {
                this.checked = data.checked;
            }
            else {
                throw new Error('Invalid data for type CHECKBOX');
            }
        }
        if (establishmentOrderSuppData.type === 'NUMBER') {
            if (data.value !== undefined) {
                this.value = data.value;
            }
            else {
                throw new Error('Invalid data for type NUMBER');
            }
        }
        if (establishmentOrderSuppData.type === 'SELECT') {
            if (data.values !== undefined) {
                this.values = data.values;
            }
            else {
                throw new Error('Invalid data for type SELECT');
            }
        }
        if (establishmentOrderSuppData.type === 'TEXT') {
            if (data.text !== undefined) {
                this.text = data.text;
            }
            else {
                throw new Error('Invalid data for type TEXT');
            }
        }
        if (establishmentOrderSuppData.type === 'CONFIRM') {
            if (data.checked !== undefined && data.checked) {
                this.checked = data.checked;
            }
            else {
                throw new Error('Invalid data for type CONFIRM');
            }
        }
    };
    OrderSuppData.prototype.isCorrect = function (establishmentOrderSuppData) {
        if (establishmentOrderSuppData.type === 'CHECKBOX') {
            return !(this.checked === undefined || this.checked === null);
        }
        if (establishmentOrderSuppData.type === 'NUMBER') {
            return !(this.value === undefined || this.value === null || isNaN(this.value));
        }
        if (establishmentOrderSuppData.type === 'SELECT') {
            if (this.values === undefined || this.values === null) {
                return false;
            }
            return true;
        }
        if (establishmentOrderSuppData.type === 'TEXT') {
            console.log("here");
            if (establishmentOrderSuppData.data instanceof EstablishmentOrderSuppDataText) {
                if (establishmentOrderSuppData.data.minLength > 0 && this.text === undefined || this.text === null || this.text === '') {
                    return false;
                }
                var dataText = establishmentOrderSuppData.data;
                if (dataText && dataText.minLength && this.text.length < dataText.minLength) {
                    return false;
                }
                if (dataText && dataText.maxLength && this.text.length > dataText.maxLength) {
                    return false;
                }
            }
            return true;
        }
        if (establishmentOrderSuppData.type === 'CONFIRM') {
            return !(this.checked === undefined || !this.checked);
        }
        return false;
    };
    return OrderSuppData;
}(Model));
export default OrderSuppData;
;
//# sourceMappingURL=OrderSuppData.js.map